export default {
      id: "optionCalculator-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#optionCalculator",
      toString: function () {
        return this.url;
      }
    }